import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@core/network/types/apiError';

/** Shared TanStack Query client. Don't retry 4xx (client) errors; do retry
 *  transient network/5xx a couple of times. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
